import React, { Component } from "react";
import { connect } from "react-redux";

import API_RESPONSE_CODE, { FULL_SCREEN_ERROR_CODES, HTTP_STATUS_CODE } from "@constants/api.response.code";

import DupontLogger from "@utils/DupontLogger";

import WPAccessDeniedPage from "@features/WPAccessDeniedPage/WPAccessDeniedPage";
import WPErrorFullPage from "@features/WPErrorFullPage";

class WPErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorData: null };
    this.logger = DupontLogger("ErrorBoundary");
  }

  static getDerivedStateFromError() {
    const errorData = { status: API_RESPONSE_CODE.APP_CRASH };
    return { hasError: true, errorData };
  }

  render() {
    let { apiError, children } = this.props;
    const { hasError, errorData } = this.state;
    if (apiError) {
      const { status, data } = apiError;
      let isUnderMaintenance = false;
      if (status === HTTP_STATUS_CODE.SERVICE_UNAVAILABLE) {
        isUnderMaintenance = data?.errorCode === API_RESPONSE_CODE.PRODUCTION_DEPLOYMENT;
        if (!isUnderMaintenance) {
          apiError = { status: API_RESPONSE_CODE.APP_CRASH };
        }
      } else if (status === API_RESPONSE_CODE.ACCESS_DENIED) {
        return <WPAccessDeniedPage />;
      }
      if (isUnderMaintenance || FULL_SCREEN_ERROR_CODES.includes(apiError.status)) {
        return <WPErrorFullPage errorData={apiError} />;
      }
    }
    if (hasError) {
      return <WPErrorFullPage errorData={errorData} />;
    }

    return children;
  }
}

const mapStateToProps = state => ({
  apiError: state.apiData.apiError,
});

export default connect(mapStateToProps)(WPErrorBoundary);
